import React, { Component } from 'react'
import classnames from 'classnames'

export default class LandingBox extends Component {

    render() {
        const {
            boxTitle,
            boxWhiteBg,
            boxInverseBg,
            noGap,
            bigGap,
            className,
        } = this.props

        return (
            <div className={classnames({
                'Landing-box': true,
                'Landing-box--white': boxWhiteBg,
                'Landing-box--inverse': boxInverseBg,
                'Landing-box--no-gap': noGap,
                'Landing-box--big-gap': bigGap,
                [className]: className,
            })}>
                {boxTitle && (
                    <h2 className={classnames({
                        'Landing-box__title': true,
                        'Landing-box__title--inverse': boxInverseBg,
                    })}>{boxTitle}</h2>
                )}
                {this.props.children}
            </div>
        )
    }
}
